export default __webpack_public_path__ + "static/media/986.64d6697f.png";